import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";

const BASE_URL = "https://nissi-india.com";

function s(v) {
  return (v ?? "").toString().trim();
}
function fmt2(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return s(v);
  return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const BataDepartmentReportPrint = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const q = new URLSearchParams(location.search);

  const finYearId = s(q.get("finYearId"));
  const branchId = s(q.get("branchId"));
  const depId = s(q.get("depId"));
  const depName = s(q.get("depName"));
  const depCode = s(q.get("depCode"));
  const fromDate = s(q.get("fromDate"));
  const toDate = s(q.get("toDate"));

  const [rows, setRows] = useState([]);
  const [companyName, setCompanyName] = useState("Nissi Infotech");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await axios.get(
      `${BASE_URL}/api/bata-abstract-report/department-print-data`,
      {
        params: {
          finYearId,
          branchId,
          depId,
          depCode,
          fromDate,
          toDate,
        },
      }
    );

    if (res.data.success) {
      setRows(res.data.rows || []);
    }
  };

  const totalAmount = rows.reduce(
    (sum, r) => sum + (Number.isFinite(Number(r.fld_total)) ? Number(r.fld_total) : 0),
    0
  );

  return (
    <div className="p-6 bg-white min-h-screen">
      {/* Top Buttons (Not Printed) */}
      <div className="print:hidden flex justify-between mb-4">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 border px-4 py-2 rounded">
          <ArrowLeft size={16} /> Back
        </button>
        <button onClick={() => window.print()} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded">
          <Printer size={16} /> Print
        </button>
      </div>

      {/* Printable Area */}
      <div className="border border-black p-4">

        {/* Header */}
        <div className="border border-black p-4 mb-4">
          <div className="text-center">
            <h2 className="font-bold text-lg">{companyName}</h2>
            <div className="text-sm">CIVIL CONSTRUCTION</div>
          </div>

          <div className="text-center font-bold mt-3">
            Bata report for the period of {fromDate} to {toDate}
          </div>

          <div className="flex justify-between mt-3 font-bold">
            <div>Department : {depName}</div>
            <div>Branch : {branchId}</div>
          </div>
        </div>

        {/* Table */}
        <table className="w-full border-collapse" style={{ border: "1px solid #000" }}>
          <thead>
            <tr>
              <th className="th">S.No</th>
              <th className="th">Emp Code</th>
              <th className="th">Emp Name</th>
              <th className="th">Designation</th>
              <th className="th">Duty Details</th>
              <th className="th">Noof Days</th>
              <th className="th">Rate</th>
              <th className="th">Total</th>
              <th className="th">Signature</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx}>
                <td className="td text-center">{idx + 1}</td>
                <td className="td text-center">{r.fld_employeecode}</td>
                <td className="td">{r.fld_employee}</td>
                <td className="td">{r.fld_designationname}</td>
                <td className="td text-center">{r.fld_dutydetails || "Days"}</td>
               <td className="td text-right">{fmt2(r.fld_noofdays ?? r.Workingdays)}</td>
<td className="td text-right">{fmt2(r.fld_rate ?? r.Daysworked)}</td>
<td className="td text-right">{fmt2(r.fld_total ?? r.fld_grosssalary)}</td>

                <td className="td"></td>
              </tr>
            ))}

            {/* Total Row */}
            <tr>
              <td colSpan={7} className="td text-right font-bold">
                Total
              </td>
              <td className="td text-right font-bold">{fmt2(totalAmount)}</td>
              <td className="td"></td>
            </tr>
          </tbody>
        </table>

        {/* Footer */}
        <div className="flex justify-between mt-12 font-bold">
          <div>Prepared By</div>
          <div>Checked By</div>
          <div>Authorized Signature</div>
        </div>
      </div>

      <style>{`
        .th {
          border: 1px solid #000;
          padding: 6px;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
        }
        .td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 12px;
        }
        @media print {
          .print\\:hidden { display: none !important; }
        }
      `}</style>
    </div>
  );
};

export default BataDepartmentReportPrint;
